<div class="flex justify-between p-6 bg-white border-b border-[#E7EAF0]">
    <div class="flex items-center">
        <p class="text-[20px] text-[#0A0A0A] font-bold">Add Bible Verse</p>
    </div>

    <div class="flex items-center">
        <img
            src="/assets/images/shared/cross-black-icon.svg"
            alt="Close"
            class="h-6 w-6 cursor-pointer"
            (click)="onCancel()" />
    </div>
</div>

<div class="px-6 pt-4">
    <div class="flex w-fit items-center bg-[#f1f5f9] p-1 rounded-full">
        <p
            class="flex items-center justify-center px-4 py-1.5 text-[0.875rem] text-center text-[#0A0A0A] font-medium rounded-full cursor-pointer"
            [ngClass]="selectedTab === 'Browse' ? 'bg-white' : ''"
            (click)="onTabSelect('Browse')">
            Browse
        </p>

        <p
            class="flex items-center justify-center px-4 py-1.5 text-[0.875rem] text-center text-[#0A0A0A] font-medium rounded-full cursor-pointer"
            [ngClass]="selectedTab === 'Search' ? 'bg-white' : ''"
            (click)="onTabSelect('Search')">
            Search
        </p>
    </div>
</div>

<div class="flex flex-col px-6 py-4">
    @if (selectedTab === 'Browse') {
        <p class="text-xs font-bold mb-2">OLD TESTAMENT</p>
        <div class="relative">
            <div class="flex overflow-x-auto gap-2 py-2 mb-2 mr-4">
                @for (bible of oldTestamentBooks(); track bible.id) {
                    <button
                        type="button"
                        class="px-4 py-2 rounded-full border text-sm font-medium transition duration-150 whitespace-nowrap"
                        [ngClass]="selectedBibleBookId() === bible.id ? 'bg-[#4F66FF] text-white' : 'bg-white'"
                        (click)="selectBibleBook(bible.id)">
                        {{ bible.type }}
                    </button>
                }
            </div>
            <div
                class="absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
        </div>
        <p class="text-xs font-bold mb-2">NEW TESTAMENT</p>
        <div class="relative">
            <div class="flex overflow-x-auto gap-2 py-2 mb-2 mr-4">
                @for (bible of newTestamentBooks(); track bible.id) {
                    <button
                        type="button"
                        class="px-4 py-2 rounded-full border text-sm font-medium transition duration-150 whitespace-nowrap"
                        [ngClass]="selectedBibleBookId() === bible.id ? 'bg-[#4F66FF] text-white' : 'bg-white'"
                        (click)="selectBibleBook(bible.id)">
                        {{ bible.type }}
                    </button>
                }
            </div>
            <div
                class="absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
        </div>

        @if (selectedBibleBookId()) {
            <p class="text-xs font-bold mb-2">CHAPTER</p>
            <div class="relative">
                <div class="flex overflow-x-auto gap-2 py-2 mb-2 mr-4">
                    @for (chapter of filteredChapters(); track chapter.id) {
                        <button
                            type="button"
                            class="flex items-center justify-center size-10 p-5 rounded-full border text-sm font-medium transition duration-150 whitespace-nowrap"
                            [ngClass]="selectedChapterId() === chapter.id ? 'bg-[#4F66FF] text-white' : 'bg-white'"
                            (click)="loadBibleVerses(chapter.id)">
                            {{ chapter.chapter.split(' ')[1] }}
                        </button>
                    }
                </div>
                <div
                    class="absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
            </div>
        }

        @if (bibleVerses().length > 0 && selectedBibleBookId()) {
            <p class="text-xs font-bold mb-2">VERSE(S)</p>
            <div class="grid grid-cols-8 py-2 gap-2">
                @for (verse of bibleVerses(); track verse.id) {
                    <button
                        type="button"
                        class="h-9 rounded-xl border text-sm font-medium"
                        [ngClass]="selectedVerseIds().includes(verse.id) ? 'bg-[#4F66FF] text-white' : 'bg-white '"
                        (click)="toggleVerseSelection(verse)">
                        {{ verse.list }}
                    </button>
                }
            </div>
        }
    }

    @if (selectedTab === 'Search') {
        <div class="relative" [ngClass]="showSearchVersesResult().length > 0 ? 'mb-4' : ''">
            <img
                src="/assets/images/shared/search-icon.svg"
                alt="Toggle password visibility"
                class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-auto" />
            <input
                id="bibleSearchInput"
                type="text"
                placeholder="Search by keyword"
                class="w-full search-form-field-container text-sm bg-white rounded-2xl"
                (input)="onSearchInput($event.target.value)" />
        </div>

        <div class="max-h-[400px] overflow-y-auto">
            @if (showSearchVersesResult().length > 0) {
                @for (verse of showSearchVersesResult(); track verse.id) {
                    <div
                        class="mt-4 p-5 flex flex-col border rounded-2xl cursor-pointer"
                        [ngClass]="selectedVerseIds().includes(verse.id) ? 'bg-[#e0efff] border-[#4F66FF]' : 'bg-white'"
                        (click)="toggleSearchVerseSelection(verse)">
                        <p class="text-xs font-bold text-[#4F66FF]">
                            {{ verse.type }} {{ verse.chapter }}:{{ verse.list }}
                        </p>
                        <p class="text-[#717182] text-sm">
                            {{ verse.verse }}
                        </p>
                    </div>
                }
            } @else {
                <div class="mt-4 p-5 flex flex-col border rounded-2xl bg-white cursor-pointer">
                    <p class="text-[#717182] text-sm text-center">No results yet. Please search for a verse.</p>
                </div>
            }
        </div>
    }

    <div class="mt-4 p-5 border rounded-2xl bg-[#f0f7ff80]">
        <div class="flex justify-between items-center mb-2">
            <p class="text-xs font-bold text-[#4F66FF]">PREVIEW</p>
            <div class="px-3 py-1 bg-white border rounded-full text-xs text-[#4F66FF] font-medium shadow-sm">
                {{ selectedVerses().length > 0 ? `${getSelectedVerseReference()}` : '—' }}
            </div>
        </div>
        @if (selectedVerses().length === 0) {
            <p class="text-[#717182] text-sm">Choose a result to preview the verse text.</p>
        } @else {
            @for (verse of selectedVerses(); track verse.id) {
                <p class="text-[#717182] text-sm">
                    {{ verse.verse }}
                </p>
            }
        }
    </div>
</div>

<div class="sticky bottom-0 flex items-center justify-between bg-white px-6 py-4 border-t border-[#E7EAF0]">
    <button
        type="button"
        class="white-border-button text-sm px-4 py-2 border-none bg-transparent rounded-full hover:text-red-600 hover:bg-red-50"
        (click)="onRemoveVerse()">
        Remove verse
    </button>
    <div class="flex gap-3">
        <button
            type="button"
            class="white-border-button text-sm px-6 py-2.5 border-none bg-transparent rounded-full"
            (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="border-button text-sm px-6 py-2.5 rounded-full" (click)="onAddSelectedVerses()">
            Save Verse
        </button>
    </div>
</div>
